import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { AiFillAppstore } from "react-icons/ai";
import "./../../Style/TableStyle.scss";
import "./../../Style/__button.scss";
import "./ExpensePurchasesPage.scss";
import { deleteAlert, errorAlert } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { AddElementsButton } from "../../Components/AddElementsButton";
import ReusableServerDataGrid from "../../Components/ReusableServerDataGrid";
// import { ExpenceGridHeader } from "../../CRUD/ExpensePurchases/ExpenceGridHeader";
import { ExpenceGridHeader } from "./ExpencePurchaseComponents/ExpenceGridHeader";
import { formatDate } from "../../Components/formatDate";
import CrudPageHeader from "../../Components/CrudPageHeader";
import ExpensePurchaseViewModal from "./ExpensePurchaseViewModal";

const formatCurrency = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default function ExpensePurchasesPage() {
  const history = useHistory();
  const { fiscalYear } = useContext(FiscalYearContext);
  const headers = authHeader();

  const [data, setData] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 50,
  });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [quickFilter, setQuickFilter] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);

  const [totals, setTotals] = useState({
    AmountWithoutVAT: 0,
    VATTotal: 0,
    Total: 0,
  });

  const fetchTotals = async (fiscal, activeFilterItems = [], activeQuickFilter = []) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "ExpensePurchases/getTotals",
        {
          headers,
          params: {
            fiscalYear: fiscal,
            filter: JSON.stringify(activeFilterItems || []),
            quickFilter: (activeQuickFilter || []).join(" "),
          },
        },
      );
      setTotals(response.data);
    } catch (error) {
      errorAlert("Gabim në marrjen e totaleve.");
    }
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${ApiLink.API_URL}ExpensePurchases/getAllExpenseData`,
        {
          headers,
          params: {
            fiscalYear,
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: JSON.stringify(sortModel),
            filter: JSON.stringify(filterModel.items),
            quickFilter: quickFilter.join(" "),
          },
        },
      );

      const transformedData = (response.data.items || []).map((item) => ({
        ...item,
        ...item.Account,
      }));

      setData(transformedData);
      setRowCount(response.data.total || 0);
    } catch (error) {
      errorAlert("Gabim në marrjen e listës së shpenzimeve.");
    } finally {
      setLoading(false);
    }
  };

  const fetchExportRows = async () => {
    const totalRowsToExport = Math.max(Number(rowCount) || 0, 1);

    const response = await axios.get(`${ApiLink.API_URL}ExpensePurchases/getAllExpenseData`, {
      headers,
      params: {
        fiscalYear,
        page: 0,
        pageSize: totalRowsToExport,
        sort: JSON.stringify(sortModel),
        filter: JSON.stringify(filterModel.items),
        quickFilter: quickFilter.join(" "),
      },
    });

    const items = response?.data?.items || [];
    return items.map((item, index) => ({
      ...item,
      ...item.Account,
      rowNumber: index + 1,
      InvoiceNr: item.InvoiceNr,
      Date: formatDate(item.Date),
      AccountName: item.Account?.AccountName ?? item.AccountName,
      AmountWithoutVAT: item.AmountWithoutVAT,
      VATTotal: item.VATTotal,
      Total: item.Total,
      rowInfo: item,
    }));
  };

  const handleDelete = async (deleteItemId) => {
    try {
      await axios.delete(
        ApiLink.API_URL + "ExpensePurchases/delete-expense-purchase" + `/${deleteItemId}`,
        { headers },
      );
      deleteAlert("Shpenzimi është fshirë me sukses");
      fetchData();
      fetchTotals(fiscalYear, filterModel.items, quickFilter);
    } catch (error) {
      deleteAlert("Shpenzimi nuk është fshirë me sukses");
    }
  };

  const handleEdit = (item) => {
    history.push(`/expences/expensepurchases/edit/${item.TransactionID}`, {
      expensePurchase: item,
    });
  };

  const handleView = async (item) => {
    setShowViewModal(true);
    setViewLoading(true);

    try {
      const response = await axios.get(
        `${ApiLink.API_URL}ExpensePurchases/view-mode/${item.TransactionID}`,
        { headers },
      );

      const payload = response?.data || {};
      setViewData({
        ...payload,
        InvoiceNr: payload.InvoiceNr ?? payload.invoiceNr,
        Date: payload.Date ?? payload.date,
        PayDate: payload.PayDate ?? payload.payDate,
        AccountName: payload.AccountName ?? payload.accountName,
        AccountNameSpare: payload.AccountNameSpare ?? payload.accountNameSpare,
        ExpenseAccountName: payload.ExpenseAccountName ?? payload.expenseAccountName,
        PaymentOptions: payload.PaymentOptions ?? payload.paymentOptions,
        PaymentTypeName: payload.PaymentTypeName ?? payload.paymentTypeName,
        TransactionType: payload.TransactionType ?? payload.transactionType,
        Coment: payload.Coment ?? payload.coment,
        Amount0: payload.Amount0 ?? payload.amount0,
        Amount8: payload.Amount8 ?? payload.amount8,
        Amount18: payload.Amount18 ?? payload.amount18,
        VAT8: payload.VAT8 ?? payload.vat8,
        VAT18: payload.VAT18 ?? payload.vat18,
        Total0: payload.Total0 ?? payload.total0,
        Total8: payload.Total8 ?? payload.total8,
        Total18: payload.Total18 ?? payload.total18,
        AmountWithoutVAT: payload.AmountWithoutVAT ?? payload.amountWithoutVAT,
        VATTotal: payload.VATTotal ?? payload.vatTotal,
        Total: payload.Total ?? payload.total,
      });
    } catch (error) {
      setShowViewModal(false);
      errorAlert("Gabim në marrjen e detajeve të shpenzimit.");
    } finally {
      setViewLoading(false);
    }
  };

  useEffect(() => {
    fetchTotals(fiscalYear, filterModel.items, quickFilter);
  }, [fiscalYear, filterModel, quickFilter]);

  React.useEffect(() => {
    fetchData();
  }, [paginationModel, sortModel, filterModel, quickFilter, fiscalYear]);

  const rows = data.map((item, index) => ({
    id: item.TransactionID ?? `expense-purchase-row-${index}`,
    rowNumber: paginationModel.page * paginationModel.pageSize + index + 1,
    InvoiceNr: item.InvoiceNr,
    Date: formatDate(item.Date),
    AccountName: item.AccountName,
    AmountWithoutVAT: item.AmountWithoutVAT,
    VATTotal: item.VATTotal,
    Total: item.Total,
    deleteItemId: item.TransactionID,
    rowInfo: item,
  }));

  return (
    <div className="Crud__Container EPP__page">
      <div className="EPP__content">
        <CrudPageHeader
          icon={AiFillAppstore}
          title="Lista e Shpenzimeve"
          description="Forma e Shpenzimeve: Menaxhoni, shtoni, editoni dhe fshini Fatura të Shpenzimeve."
          tutorialUrl="https://www.youtube.com/@Accountree"
          tutorialLabel="Shiko Tutorialin"
          className="EPP__header"
          action={
            <AddElementsButton
              text="Krijo nje Shpenzim"
              icon="bi bi-plus-circle"
              className="button-68"
              onClick={() => history.push("/expences/expensepurchases/new")}
            />
          }
        />

        <ReusableServerDataGrid
          columns={ExpenceGridHeader}
          rows={rows}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onView={handleView}
          showViewAction={true}
          showPayment={true}
          actionsMinWidth={80}
          height={620}
          rowCount={rowCount}
          loading={loading}
          paginationModel={paginationModel}
          setPaginationModel={setPaginationModel}
          sortModel={sortModel}
          setSortModel={setSortModel}
          filterModel={filterModel}
          setFilterModel={setFilterModel}
          quickFilter={quickFilter}
          setQuickFilter={setQuickFilter}
          getExportRows={fetchExportRows}
          summaryFooter={{
            labelField: "AccountName",
            label: "Totali",
            values: {
              AmountWithoutVAT: formatCurrency(totals.AmountWithoutVAT),
              VATTotal: formatCurrency(totals.VATTotal),
              Total: formatCurrency(totals.Total),
            },
          }}
        />

        <ExpensePurchaseViewModal
          show={showViewModal}
          onHide={() => {
            setShowViewModal(false);
            setViewData(null);
          }}
          data={viewData}
          loading={viewLoading}
        />
      </div>
    </div>
  );
}
